import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    FormHelperText,
    Grid,
    Input,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";

import { useFormik } from "formik";
import { errorToast, successToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import Loader from "../../helpers/constants/Loader";
import { isString } from "../../utils/validation";
import { useEditRequestMutation, useLazyGetRequestByIdQuery } from "../../services/companyRequest";
import { ROLE } from "../../constants/enums";



const EditCompanyRequest = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [ByIdDetails, setByIdDetails] = useState<any>();
    const navigate = useNavigate();
    const [dialCode, setPhoneCode] = useState("+971");
    const [editUSERbyId] = useEditRequestMutation();
    const { id } = useParams();
    const [fetchApi] = useLazyGetRequestByIdQuery();


    const fetchDataById = async () => {
        try {
            setIsLoading(true);
            const response = await fetchApi({ userId: id }).unwrap();
            if (response.statusCode === 200) {
                setByIdDetails(response?.data );
                setPhoneCode(response?.data?.dialCode || "");
                formik.setFieldValue('firstName',response?.data?.firstName);
                formik.setFieldValue('lastName',response?.data?.lastName)
                formik.setFieldValue('email',response?.data?.email)
                formik.setFieldValue('phoneNo',response?.data?.phoneNo)
                formik.setFieldValue('companyName',response?.data?.companyName)
                formik.setFieldValue('noOfAgents',response?.data?.noOfAgents)
                formik.setFieldValue('agencyType',response?.data?.agencyType)
                formik.setFieldValue('listingPerMonth',response?.data?.estimateListingPerMonth)
               
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    };

    

    const formik = useFormik({
        initialValues: {
            firstName: ByIdDetails?.firstName || "",
            lastName: ByIdDetails?.lastName || "",
            email: ByIdDetails?.email || "",
            phoneNo: ByIdDetails?.phoneNo || "",
            dialCode: dialCode,
            companyName: ByIdDetails?.companyName || "",
            noOfAgents: ByIdDetails?.noOfAgents || "",
            listingPerMonth: ByIdDetails?.estimateListingPerMonth || "",
            agencyType: ByIdDetails?.agencyType || "",
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .required("Email is required")
                .matches(
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    "Enter a valid email address"
                )
                .matches(
                    /^[^\uD800-\uDBFF\uD800-\uDBFF]+$/,
                    "Emojis are not allowed in the email address"
                ),
            firstName: Yup.string()
                .required("First name is required")
                .min(2, "Minimum 2 characters are required")

                .matches(
                    /^[a-zA-Z\s]+$/,
                    "Full name must contain only letters and spaces"
                ),
            companyName: Yup.string()
                .required("Company name is required")
                .min(2, "Minimum 2 characters are required"),

            noOfAgents: Yup.string()
                .required("This field is required"),

            listingPerMonth: Yup.string()
                .required("This field is required"),

            agencyType: Yup.string()
                .required("This field is required"),



            lastName: Yup.string()
                .min(2, "Minimum 2 characters are required"),


            phoneNo: Yup.string()
                .required("Phone number is required")
                .min(7, "Phone number must be at least 7 characters"),

        }),
        onSubmit: async (values, { setSubmitting }) => {
            formik.setSubmitting(true);
            let body: any = {
                firstName: values.firstName || "",
                lastName: values.lastName || "",
                email: values.email || "",
                dialCode: dialCode,
                phoneNo: values.phoneNo || "",
                companyName: values.companyName || "",
                noOfAgents: values.noOfAgents || "",
                estimateListingPerMonth: values.listingPerMonth || "",
                agencyType: values.agencyType || '',
            };
            if (!id) {
                body = { ...body, role: ROLE.INDIVIDUAL_USER };
            }
            let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

            try {
                setIsLoading(true);
                const response = await editUSERbyId({
                    id:id,
                    body: encryptedBody,
                }).unwrap();
                if (response?.statusCode === 200) {
                    successToast("User updated successfully");
                    navigate("/manage-company-requests");
                }
                setIsLoading(false);
            } catch (error: any) {
                setIsLoading(false);
                console.error(error);
                errorToast(error?.data?.message);
            } finally {
                setIsLoading(false);
                setSubmitting(false);
            }

        },
    });

    const handleChangePhone = (phone: any, country: any) => {
        formik.setFieldValue("phoneNo", phone?.replace(country?.dialCode, ""));
        setPhoneCode(
            country?.dialCode.includes("+")
                ? country?.dialCode
                : "+" + country?.dialCode
        );
    };

    useEffect(() => {
        fetchDataById();
    }, []);


    return (
        <div>
            <div className="main_loyout">
                <div className="dashboard">
                    <h1 className="mn_hdng">Edit company Request</h1>
                    <Loader isLoad={isLoading} />
                    <Button
                        className="btn btn_primary"
                        onClick={() => {
                            navigate("/manage-company-requests");
                        }}
                    >
                        Back
                    </Button>
                </div>
                <Card className="cards">
                    <form onSubmit={formik.handleSubmit}>
                        <CardContent sx={{ p: 0, pb: 0 }}>
                            <Grid container spacing={2}>

                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                    <Typography className="custom_label">First Name</Typography>
                                    <TextField
                                        hiddenLabel
                                        type={"text"}
                                        name="firstName"
                                        variant="outlined"
                                        fullWidth
                                        placeholder="First Name"
                                        onBlur={formik.handleBlur}
                                        value={formik.values.firstName}
                                        className="text_field"
                                        onChange={(val) => {
                                            if (
                                                val.target.value === " " ||
                                                val.target.value === "."
                                            ) {
                                            } else if (isString(val.target.value)) {
                                                formik.handleChange(val);
                                            }
                                        }}
                                        helperText={
                                            formik.touched.firstName && formik.errors.firstName
                                                ? formik.errors.firstName.toString()
                                                : ""
                                        }
                                    ></TextField>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                    <Typography className="custom_label">Last Name</Typography>
                                    <TextField
                                        hiddenLabel
                                        type={"text"}
                                        name="lastName"
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Last Name"
                                        onBlur={formik.handleBlur}
                                        value={formik.values.lastName}
                                        className="text_field"
                                        onChange={(val) => {
                                            if (
                                                val.target.value === " " ||
                                                val.target.value === "."
                                            ) {
                                            } else if (isString(val.target.value)) {
                                                formik.handleChange(val);
                                            }
                                        }}
                                        helperText={
                                            formik.touched.lastName && formik.errors.lastName
                                                ? formik.errors.lastName.toString()
                                                : ""
                                        }
                                    ></TextField>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                    <Typography className="custom_label">Company Name</Typography>
                                    <TextField
                                        hiddenLabel
                                        type={"text"}
                                        name="companyName"
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Company Name"
                                        onBlur={formik.handleBlur}
                                        value={formik.values.companyName}
                                        className="text_field"
                                        onChange={(val) => {
                                            if (
                                                val.target.value === " " ||
                                                val.target.value === "."
                                            ) {
                                            } else if (isString(val.target.value)) {
                                                formik.handleChange(val);
                                            }
                                        }}
                                        helperText={
                                            formik.touched.companyName && formik.errors.companyName
                                                ? formik.errors.companyName.toString()
                                                : ""
                                        }
                                    ></TextField>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                    <Typography className="custom_label">Company Email</Typography>
                                    <TextField
                                        className="text_field"
                                        hiddenLabel
                                        type={"text"}
                                        name="email"
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Email"
                                        value={formik.values.email}
                                        onChange={(val) => {

                                            if (
                                                val.target.value == " "
                                            ) {

                                            } else {
                                                formik.handleChange(val);
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                        helperText={
                                            formik.touched.email && formik.errors.email
                                                ? formik.errors.email.toString()
                                                : ""
                                        }
                                    ></TextField>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                    <Typography className="custom_label">Company Phone Number</Typography>
                                    <PhoneInput
                                        value={dialCode + formik.values.phoneNo}
                                        country={"ae"}
                                        placeholder="0 (000) 000-000"
                                        enableSearch={true}
                                        inputStyle={{ width: "100%" }}
                                        onChange={(phone, country) =>
                                            handleChangePhone(phone, country)
                                        }
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.phoneNo && formik.errors.phoneNo ? (
                                        <h6 className="err_msg">
                                            {formik.touched.phoneNo &&
                                                formik.errors.phoneNo.toString()}
                                        </h6>
                                    ) : (
                                        ""
                                    )}
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                    <Typography className="custom_label">Number of agents</Typography>
                                    <TextField
                                        className="text_field"
                                        hiddenLabel
                                        type={"text"}
                                        name="noOfAgents"
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Number Of Agents"
                                        value={formik.values.noOfAgents}
                                        onChange={(val) => {

                                            if (
                                                val.target.value == " "
                                            ) {

                                            } else {
                                                formik.handleChange(val);
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                        helperText={
                                            formik.touched.noOfAgents && formik.errors.noOfAgents
                                                ? formik.errors.noOfAgents.toString()
                                                : ""
                                        }
                                    ></TextField>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                    <Typography className="custom_label">Estimated listings per month</Typography>
                                    <TextField
                                        className="text_field"
                                        hiddenLabel
                                        type={"text"}
                                        name="listingPerMonth"
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Listing per month"
                                        value={formik.values.listingPerMonth}
                                        onChange={(val) => {

                                            if (
                                                val.target.value == " "
                                            ) {

                                            } else {
                                                formik.handleChange(val);
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                        helperText={
                                            formik.touched.listingPerMonth && formik.errors.listingPerMonth
                                                ? formik.errors.listingPerMonth.toString()
                                                : ""
                                        }
                                    ></TextField>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={12}>
                                    <Typography className="custom_label">Signing up as</Typography>
                                    <Select
                                        className="select_div"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={formik.values.agencyType}
                                        onChange={formik.handleChange}
                                        displayEmpty
                                        onBlur={formik.handleBlur}
                                        disabled

                                    >
                                        <MenuItem value="" disabled>
                                            Select
                                        </MenuItem>

                                        <MenuItem value="1">Real Estate Broker </MenuItem>
                                        <MenuItem value="2">Short Term Rentals </MenuItem>
                                    </Select>
                                    {formik.touched.agencyType && formik.errors.agencyType && (
                                        <FormHelperText sx={{ color: "red" }}>
                                            {String(formik.errors.agencyType)}
                                        </FormHelperText>
                                    )}
                                </Grid>

                            </Grid>
                            <div className="form_btn">
                                <Button size="large" type="submit" className="btn btn_primary">
                                    Save
                                </Button>
                            </div>
                        </CardContent>
                    </form>
                </Card>
            </div>
        </div>
    );
};

export default EditCompanyRequest;
